








import { defineComponent } from "@vue/composition-api";
import useDarkModeController from "@/hooks/useDarkModeController";
import BaseIcon from "@/components/BaseIcon";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "DarkModeSwitch",
  components: { BaseSwitch, BaseIcon },
  setup() {
    const { toggleDarkMode, isDarkMode } = useDarkModeController();

    return { toggleDarkMode, isDarkMode };
  },
});
